import { UseQueryResult, useQuery, useQueryClient } from '@tanstack/react-query';

import type { Cart } from '@getjust/gateway';

import { CART_QUERY_KEY } from '$src/constants';
import { useBaseApiUrl } from '$src/hooks/client/useBaseApiUrl';
import { useCartIdAtom } from '$src/hooks/state';
import { gateway, hasXCountryGatewayHeader } from '$src/http';

export function useCart(): UseQueryResult<Cart> {
  const baseUrl = useBaseApiUrl();
  const queryClient = useQueryClient();
  const { cartId } = useCartIdAtom();
  return useQuery({
    queryKey: [CART_QUERY_KEY, cartId],
    queryFn: async () => {
      const response = await gateway.get<Cart>(`${baseUrl}`);
      if (response?.data?.taxReady === false || response?.data?.shipping?.ready === false) {
        queryClient.invalidateQueries({ queryKey: [CART_QUERY_KEY] });
      }
      return response.data;
    },
    enabled: Boolean(baseUrl) && Boolean(hasXCountryGatewayHeader()) && Boolean(cartId),
  });
}
